"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocalizedTextResolver = void 0;
class LocalizedTextResolver {
    constructor(locale, defaultLocales, unresolvedLabel) {
        this.locale = locale;
        this.defaultLocales = defaultLocales;
        this.unresolvedLabel = unresolvedLabel;
    }
    resolve(text) {
        if (!text) {
            return undefined;
        }
        // build locales array ordered by priority:
        //  1. required locale
        //  2. default locales as given in order
        //  3. the first object property (which is probably alpha-sorted or any random value)
        const locales = [this.locale].concat(this.defaultLocales).concat(Object.keys(text)[0]);
        const l = locales.length;
        let i = 0;
        for (; i < l; i++) {
            if (text[locales[i]])
                return text[locales[i]];
        }
        return this.unresolvedLabel;
    }
}
exports.LocalizedTextResolver = LocalizedTextResolver;
//# sourceMappingURL=LocalizedTextResolver.js.map